<template>
    <b-form-group
        :label="label"
        :label-for="id"
        :label-class="labelClass"
        :description="description"
    >
        <b-form-textarea
            :id="id"
            :rows="3"
            :value="value"
            :state="state"
            :disabled="disabled"
            :placeholder="placeholder"
            @input="onInput"
        />
        <b-form-invalid-feedback :id="id + '-feedback'">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
export default {
    name: 'CTextArea',
    props: [
        'id',
        'value',
        'state',
        'disabled',
        'label',
        'placeholder',
        'labelClass',
        'description',
    ],
    methods: {
        onInput(newValue) {
            const lines = this.parseTextToArrayOfTextLines(newValue)
            this.$emit('update:value', newValue)
            this.$emit('lines', lines)
        },
        parseTextToArrayOfTextLines(text) {
            if (!text) {
                return []
            }

            const names = text.trim()
            return names.length ? names.split('\n').map(n => n.trim()) : []
        },
    },
}
</script>
